var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbKalyanLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 107,
    viewBox: "0 0 74 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_251_1063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47958 61.1185L0 81.5484C0 104.749 46.0019 104.749 51.9648 104.749C57.9335 104.749 73.0317 107 73.0317 107C68.8178 67.6969 35.462 50.0376 35.462 50.0376L9.47958 61.1185Z",
    fill: "url(#paint0_linear_251_1063)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.174805 26.1437V83.6255C3.0948 78.1439 7.7043 73.7183 13.3389 70.9866C28.9622 63.3682 68.8161 44.6689 73.0286 0C73.0286 0 57.0523 2.77058 48.6259 4.15587C40.5538 5.36711 0.349844 5.70668 0.174805 26.1437Z",
    fill: "url(#paint1_linear_251_1063)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_251_1063",
    x1: 58.2793,
    y1: 76.9239,
    x2: 27.9288,
    y2: 165.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#FED600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#956B29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30130D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_251_1063",
    x1: 98.5274,
    y1: 163.153,
    x2: -11.9979,
    y2: 164.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FFCD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B16B28"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_251_1063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.0317,
    height: 107,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbKalyanLogo);
export default __webpack_public_path__ + "static/media/FbKalyanLogo.9e3fd196b8ccca22a4fa2ca32f32e52d.svg";
export { ForwardRef as ReactComponent };